


















import { Vue, Component } from "@/shared/vuepack";
@Component({
  components: {
  }
})
export default class AvidiaOnboardingInfo extends Vue {

}
